/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MarkSentResponse interface.
 */
export function instanceOfMarkSentResponse(value) {
    if (!('recorded' in value) || value['recorded'] === undefined)
        return false;
    return true;
}
export function MarkSentResponseFromJSON(json) {
    return MarkSentResponseFromJSONTyped(json, false);
}
export function MarkSentResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'recorded': json['recorded'],
    };
}
export function MarkSentResponseToJSON(json) {
    return MarkSentResponseToJSONTyped(json, false);
}
export function MarkSentResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'recorded': value['recorded'],
    };
}
